<template>
  <b-form>
    <b-form-group
      label="Website"
      label-for="qWeb"
      description="If you have a website or facebook page that informs about your quiz, you can put it here."
    >
      <b-form-input
        id="qWeb"
        type="url"
        :value="presetWeblink"
        trim
        lazy
        @update="webLinkChanged"
        autofocus
      />
    </b-form-group>

    <b-form-group
      label="Video stream"
      label-for="qStream"
      description="If you stream your quiz online, put the link to your stream here to make it easier for quizzers to find it."
    >
      <b-form-input
        id="qStream"
        type="url"
        v-model="quiz.link_to_stream"
        trim
        lazy
        @change="checkValidity"
        autofocus
      />
    </b-form-group>
  </b-form>
</template>
<script>
import constants from "@/assets/constants.js";
import { Web } from "@/assets/convenience.js";

export default {
  name: "NewQuizPageLinks",
  props: ["quiz", "validity"],
  model: {
    prop: "validity",
    event: "validity"
  },
  watch: {
    presetWeblink(newValue) {
      if (this.quiz.link_to_website != newValue) {
        this.quiz.link_to_website = newValue;
      }
    }
  },
  computed: {
    presetWeblink() {
      if (
        this.quiz &&
        this.quiz.link_to_website &&
        this.quiz.link_to_website.length > 0
      ) {
        return this.quiz.link_to_website;
      }

      if (!this.$store.state.presetStore.presets) {
        return "";
      }

      var preset = this.$store.state.presetStore.presets[
        constants.PRESET_ID_HOST_WEB_LINK
      ];

      if (!preset) {
        return "";
      }

      return preset;
    }
  },
  created() {
    this.quiz.link_to_website = this.presetWeblink;
    this.checkValidity();
  },
  methods: {
    webLinkChanged(val) {
      this.quiz.link_to_website = val;
      this.checkValidity();
    },
    checkValidity() {
      var valid = true;

      if (
        this.quiz.link_to_website.length > 0 &&
        !Web.isValidWebUrl(this.quiz.link_to_website)
      ) {
        valid = false;
      }

      if (
        this.quiz.link_to_stream.length > 0 &&
        !Web.isValidWebUrl(this.quiz.link_to_stream)
      ) {
        valid = false;
      }

      this.$emit("validity", valid);
    }
  }
};
</script>
